import {
    Directive,
    HostListener,
    Input,
} from "@angular/core";

import { NO_IMAGE_PLACEHOLDER } from "../../common/constants";
import { isSupplierNoImagePlaceholder } from "../utils/product-image.utils";

@Directive({
    selector: "img[vsfFallbackSrc]",
    standalone: true,
})
export class FallbackSrcDirective {
    @Input() vsfFallbackSrc: string = NO_IMAGE_PLACEHOLDER;

    @HostListener("error", ["$event"])
    onError(event: Event): void {
        this.applyFallback(event.target as HTMLImageElement | null);
    }

    @HostListener("load", ["$event"])
    onLoad(event: Event): void {
        const img = event.target as HTMLImageElement | null;
        if (!img) {
            return;
        }
        const src = img.currentSrc || img.src;
        if (
            isSupplierNoImagePlaceholder(src) ||
            src.includes(this.vsfFallbackSrc || NO_IMAGE_PLACEHOLDER)
        ) {
            this.applyFallback(img);
        }
    }

    private applyFallback(img: HTMLImageElement | null): void {
        if (!img) {
            return;
        }
        const fallback = this.vsfFallbackSrc || NO_IMAGE_PLACEHOLDER;
        img.classList.add("opacity-20");
        if (img.src.includes(fallback)) {
            return;
        }
        img.src = fallback;
    }
}
